import { cloneElement, useContext, useEffect, useRef, useState } from 'react';
import Item from '../../../../components/Lists/Item';
import { DropdownsContext, useDropdownConfig } from '../../../../contexts/DropdownsContext';
import './InterchangeabilityList.css';
import Input from '../../../../components/Inputs/Input';
import { DndContext, useDraggable, useDroppable } from '@dnd-kit/core';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import { ataFormatter } from '../../../../utils/utils';
import { createInterchangeability, deleteInterchangeability, getInterhcangeabilities, postInterchangeability, targetInterchangeabilities } from '../../services/InterchangeabilityService';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import { ConditionalNote } from './ConditionalNote';
import { Badge } from '../../../../components/Badge/Badge';
import { Tooltip } from '@mui/material';
import { PartsSelector } from './PartsSelector';
import useDialog from '../../../../hooks/useDialog';
import { InterchangeabilitySummary } from './InterchangeabilitySummary';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import DeletePartDialog from './DeletePartDialog';
// import { Badge } from '@mui/material';



const itemUpdater = {
  "targetPartId": (value) => ({ "targetPartId": value.id, "PN": value.part_number, targetPartNumber: value.part_number }),
  "conditionalNote": (value) => ({ "conditionalNote": value, "Conditional Notes": value })
}

const mappedItem = (item) => ({ ...item, part: { id: item.targetPartId, partNumber: item.targetPartNumber, description: item.targetPartName || "--", ata: `${item.aviationPart?.atachapterName || "00"}-${item.aviationPart?.atasectionName || "00"}-${item.aviationPart?.ataparagraphName || "00"}` } });

//FIXME: use the source aviationPart;
//FIXME: Instead of mapping to a modified object, change make the info shown dynamic.
const mappedItemTarget = (item) => ({ ...item, part: { id: item.sourcePartId, partNumber: item.sourcePartNumber, description: item.sourcePartName || "--", ata: `${item.aviationPart?.atachapterName || "00"}-${item.aviationPart?.atasectionName || "00"}-${item.aviationPart?.ataparagraphName || "00"}` } });

const isBothWays = { "Both Ways": true, "One Way Forward": false, "One Way To Part": false };

const Counter = ({ interchangebilities }) => {
  return (["Both Ways", "One Way Forward", "One Way To Part"].map(type =>
    <div className='counter'>
      <i className={type === "Both Ways" ? 'icon-two-way' : 'icon-one-way'}></i>
      <span className='name'>{type}</span>
      <span className='count'>{(interchangebilities[type] ?? []).length}</span>
    </div>
  ))
}

const placeholders = {
  "Both Ways": "No both-ways interchangeabilities",
  "One Way Forward": "No one-way interchangeabilities",
  "One Way To Part": "No one-way interchangeabilities to this part"
}

const DropArea = ({ updateSections, targetType, partId, handleResponse }) => {
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const { openDialog } = useDialog();

  const updateInterchangebility = (updatedItem) => {
    infoMsg("Updating Interchangeability");
    createInterchangeability(partId, [updatedItem]).then(response => {
      if (response.data.responseCode === 204) {
        successMsg("Interchangeability updated", `Interchangeability changed to ${targetType}`);
        handleResponse(response.data.load);
        // updateSections(prev => ({
        //   ...prev,
        //   [sourceType]: prev[sourceType].filter(i => i.id !== item.id),
        //   [type]: [item, ...prev[type]]
        // }))
      } else {
        warningMsg("Something went wrong");
      }
    }).catch(error => {
      warningMsg("Something went wrong");
      console.error(error);
    })
  }

  const partDrop = (e, type) => {
    let data = JSON.parse(e.dataTransfer.getData("text/plain"));
    let { item, sourceType } = data;
    if (type !== sourceType) {
      openDialog({ component: InterchangeabilitySummary, props: { item, bothWays: isBothWays[type], okClick: () => updateInterchangebility({ ...item, bothWays: isBothWays[type] }) } })

    }
    // let { partId, sourceType } = JSON.parse(e.dataTransfer.getData('data'));
    // updateSections(prev => {
    //   let part = prev[sourceType]?.find(p => p.id === partId);
    //   return {
    //     ...prev,
    //     [sourceType]: prev[sourceType].filter(p => p.id !== partId),
    //     [type]: [(part), ...prev[type]]
    //   }
    // })
  }

  const { setNodeRef } = useDroppable({
    id: targetType
  })

  return (
    <div ref={setNodeRef} onDragOver={e => e.preventDefault()} onDrop={(e) => partDrop(e, targetType)} className='drop-area'>
      <span>Drag Part</span>
    </div>
  )

}

const InterchangeabilityList = ({ part }) => {

  const { config } = useDropdownConfig(1);
  const dropdownContext = useContext(DropdownsContext);

  const { successMsg, infoMsg, warningMsg, errorMsg } = useSnackBar();

  // !intialize state empty
  const [interchangesByType, setinterchangesByType] = useState({
    "Both Ways": [],
    "One Way Forward": []
  });

  const [partsSet, setpartsSet] = useState();

  useEffect(() => {
    // Include current part ID to avoid self-interchangeability
    setpartsSet(new Set([part.id, ...(interchangesByType["Both Ways"].map(i => i.part.id)), ...(interchangesByType["One Way Forward"].map(i => i.part.id))]))
    // setpartsSet({
    //   "Both Ways": new Set([...(interchangesByType["Both Ways"].map(i => i.part.id)), part.id]),
    //   "One Way Forward": new Set([...(interchangesByType["One Way Forward"].map(i => i.part.id)), part.id])
    // })
  }, [interchangesByType])

  const handleResponse = (load) => {
    let bothWays = load.filter(i => i.bothWays).map(mappedItem);
    let oneWay = load.filter(j => !j.bothWays).map(mappedItem);
    setinterchangesByType(prev => ({
      ...prev,
      "Both Ways": bothWays,
      "One Way Forward": oneWay,
    }))
  }

  const loadInterchangeabilities = (part) => {
    // ! AutoSelect dropdown parts from interchangeabilities
    getInterhcangeabilities(part.id).then(response => {
      if (response.data.responseCode === 200) {
        targetInterchangeabilities(part.id).then(responseTarget => {
          if (responseTarget.data.responseCode === 200) {
            handleResponse(response.data.load);
            setinterchangesByType(prev => ({ ...prev, "One Way To Part": responseTarget.data.load.map(mappedItemTarget) }));
            return;
          } else {
            warningMsg("Something went wrong", responseTarget.data.message);
          }
          handleResponse(response.data.load);
        })
      } else {
        warningMsg("Something went wrong", responseTarget.data.message);
      }
    });


  }


  const updateDropdown = (dropdownId, parentValues, dependenciesToUpdate) => {
    dropdownContext.setDropdownsData((prevDropdowns) =>
      prevDropdowns.map((filter) => {
        if (filter.id === dropdownId) {
          return {
            ...filter,
            parentValues,
            dependenciesToUpdate,
            reload: true,
          };
        }
        return filter;
      })
    );
  };

  const resetDropdownsReload = () => {
    dropdownContext.setDropdownsData((filterState) => {
      if (filterState.length > 0) {
        return filterState.map((e) => {
          if (e.reload) {
            return { ...e, reload: false };
          }
          return e;
        });
      }
      return filterState;
    });
  };

  const dragEnd = (e) => {

    const { active, over } = e;
    // if (!over) return;

    // const type = over.id;
    // const { item, sourceType } = active.data.current;

    // setinterchangesByType(prev => {
    //   let part = prev[sourceType]?.find(p => p.id === item.id);
    //   return {
    //     ...prev,
    //     [sourceType]: prev[sourceType].filter(p => p.id !== item.id).map(mappedItem),
    //     [type]: [(part), ...prev[type]]
    //   }
    // });
  }

  const saveButtons = [
    { label: 'Save and Finish', onClick: () => { }, icon: "icon-save", id: 'save' },
    { label: 'Save and Continue Editing', onClick: () => { }, icon: "icon-save", id: 'save-continue' },
    { label: 'Cancel', onClick: () => { }, icon: "icon-cross", id: 'cancel', type: 'danger' }
  ];

  const applySelection = (type, selection, conditionalNote) => {
    // valid new Interhcnageabilities

    // valid all promises to successfully resolve;
    if (selection?.length > 0) {
      infoMsg("Saving interchangeabilities");


      Promise.all(selection.map(selectionPart => postInterchangeability(part.id, { id: null, status: null }).then(response => ({ ...response.data.load, targetPartId: selectionPart.id }))))
        .then(responses => {
          createInterchangeability(part.id, responses.map(r => ({
            ...r,
            sourcePartId: part.id,
            bothWays: isBothWays[type],
            conditionalNote: conditionalNote || ""
          }))).then(response => {
            if (response.data.responseCode < 300 && response.data.responseCode > 199) {
              handleResponse(response.data.load);
              successMsg("Interchangeabilities updated");
            }
          })
        })
    }

  };

  const [editionMode, setEditionMode] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);

  useEffect(() => {
    loadInterchangeabilities(part);
  }, [part]);

  const [searchvalue, setSerachValue] = useState({
    "Both Ways": "", "One Way Forward": "", "One Way To Part": ""
  })

  return (
    <div className={`list interchangeability-list-component`}>
      {/* <DndContext onDragEnd={dragEnd}> */}
      <Expandable2 summary={
        <Item ignoreProperties={["id"]} item={{
          id: part.id,
        }}
          itemSuffix={() =>
            <div className='interchange-actions'>
              {editionMode ? <button onClick={() => setEditionMode(false)} className='filled small-size'>
                Finish
              </button> : (
                openStatus ? <button onClick={(e) => { setEditionMode(true); }} className='transparent' tabIndex={0}>
                  <i className='icon-edit'>
                  </i>
                </button> :
                  <div onClick={(e) => { setEditionMode(true); }} className='transparent' tabIndex={0}>
                    <i className='icon-edit'>
                    </i>
                  </div>)}
            </div>

          }

        >
          <Counter interchangebilities={interchangesByType} />
        </Item>
      }
        onOpenChange={(e) => setOpenStatus(e)}
      >
        {/* <div className='conditional-notes-container'>
            <b style={{ fontSize: '0.6rem' }}>Conditional Notes</b>
            <textarea></textarea>
          </div> */}
        {/* {JSON.stringify(Array.from(partsSet["One Way Forward"]))} */}

        <div className='interchange-grid'>
          {["Both Ways", "One Way Forward", "One Way To Part"].map(typeitem =>
            <div className='interchange-type'>
              <div className='interchange-header'>
                <i className={typeitem === "Both Ways" ? 'icon-two-way' : 'icon-one-way'}></i>
                <span>{typeitem}</span>
                {(typeitem !== "One Way To Part" && editionMode) ? <DialogTrigger dialogContent={{ component: PartsSelector, props: { type: typeitem, subCategory: part.subCategoryId, onApplySelection: (items, conditionalNote) => applySelection(typeitem, items, conditionalNote), previousSelection: partsSet, sourcePart: part } }} >
                  <button className='outlined icon tiny'><i className='icon-add-new'></i></button>
                </DialogTrigger> : <div></div>}

                <Input placeholder="Search" onChange={(e) => setSerachValue(prev => ({ ...prev, [typeitem]: e.target.value }))} />
              </div>
              {typeitem !== "One Way To Part" && (editionMode) && <DropArea handleResponse={handleResponse} updateSections={setinterchangesByType} targetType={typeitem} partId={part.id} />}
              <div className='interchange-part-list'>
                {
                  // JSON.stringify(interchangesByType)
                  interchangesByType[typeitem]?.filter(i => i.part.partNumber.includes(searchvalue[typeitem])).map(interchangeItem =>
                    // (<Draggable data={{ partId: interchangeItem.id, sourceType: typeitem }}>

                    //   <div className='interchange-list-item'>
                    //     <i className='icon-draggable'></i>
                    //     <b>{interchangeItem.partNumber}</b>
                    //     <span>{interchangeItem.description}</span>
                    //     <span>{interchangeItem.ata}</span>
                    //     <i className='icon-bin'></i>
                    //   </div>
                    // </Draggable>)
                    <Draggable disabled={!editionMode || typeitem === "One Way To Part"} data={{ item: interchangeItem, sourceType: typeitem }}>

                      <InterchangeItem disabled={!editionMode || typeitem === "One Way To Part"} handleResponse={handleResponse} item={interchangeItem} sourceType={typeitem} setInterchanges={setinterchangesByType} />
                    </Draggable>
                  )
                }
                {!(interchangesByType[typeitem]?.length > 0) &&
                  <div className='placeholder'>
                    <i>{placeholders[typeitem]}</i>
                  </div>
                }
              </div>

            </div>)}
        </div>
      </Expandable2>
      {/* </DndContext> */}

    </div>
  )
}

const mock = [
  {
    id: 0,
    "Current Part": "Part-A",
    "PN Description": "Engine Assembly",
    "ATA": "12-11-45",
  }
];

const partsById = {
  0: {
    "Both Ways": [{ id: 0, part: { id: 10, partNumber: "PART-C", description: "Lorem ipsum name 01", ata: "12-11-45" } }, { id: 1, part: { id: 12, partNumber: "PART-B", description: "Lorem ipsum name 02", ata: "12-11-45" } }],
    "One Way Forward": [{ id: 2, part: { id: 11, partNumber: "PART-E", description: "Lorem ipsum name 02", ata: "12-11-45" } }, { id: 3, part: { id: 13, partNumber: "PART-D", description: "Lorem ipsum name 02", ata: "12-11-45" } }],
    "One Way To Part": []
  }
}

const InterchangeItem = ({ item, sourceType, setInterchanges, handleResponse, disabled }) => {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: item.id,
    data: { interchange: item, sourceType }
  });

  const style = transform ? {
    transform: `translate(${transform.x}px, ${transform.y}px )`
  } : undefined;

  const { successMsg, infoMsg, warningMsg, errorMsg } = useSnackBar();

  const deleteItem = (item) => {
    infoMsg("Removing interchangeability");
    deleteInterchangeability(item.id).then(response => {
      if (response.data.responseCode === 204) {
        successMsg("Interchangeability Deleted", `${isBothWays[sourceType] ? 'Both Ways' : 'One Way'} interchangeability to part ${item.part.partNumber} was deleted `, 4000);
        setInterchanges(prev => ({
          ...prev,
          [sourceType]: prev[sourceType].filter(i => i.id !== item.id)
        }))
      }
    })
  }

  return (
    <div style={style} {...listeners} {...attributes} className={`interchange-list-item ${item.inherited ? 'inherited' : ''}`}>
      {/* <div className='interchange-list-item'> */}
      <div className='icons'>
        {!disabled && <i className='icon-draggable'></i>}
        {item.inherited &&
          <Tooltip title={"Part added automatically due to existing relations"} arrow>
            <i className='icon-info'></i>
          </Tooltip>
        }

      </div>

      {(item.part.partNumber?.length > 19) ? <Tooltip arrow title={item.part.partNumber}>
        <b>{item.part.partNumber}</b>
      </Tooltip> :
        <b>{item.part.partNumber}</b>
      }
      {/* <span>{item.part.description}</span> */}
      <span>{item.part.ata}</span>
      <DialogTrigger dialogContent={{ component: ConditionalNote, props: { item, handleResponse, groupType: sourceType, editing: !disabled } }}>
        <button onClick={() => { }}>
          <Badge content={Boolean(item.conditionalNote?.trim())}>
            <i className='icon-notes'></i>
          </Badge>
          {/* <Badge color="secondary" variant="dot" anchorOrigin={{ vertical: 'bottom',  horizontal: 'right' }}> */}
          {/* </Badge> */}
        </button>
      </DialogTrigger>
      {!disabled && <DialogTrigger dialogContent={{ component: DeletePartDialog, props: { item: {}, message: `Are you sure you want to remove the interchangeability to part ${item.part.partNumber}`, onDelete: () => deleteItem(item) } }}>
        <i className='icon-delete-new'></i>

      </DialogTrigger>}
      {/* {!disabled && <button onClick={() => deleteItem(item)}>
        <i className='icon-delete-new'></i>
      </button>} */}
    </div>
  )
}



export const Draggable = ({ children, data, disabled, ...props }) => {

  const cloneElement = (e) => {
    e.dataTransfer.setData("text/plain", JSON.stringify(data));
    e.stopPropagation();
  }

  return (<div style={{ cursor: (!disabled) ? "grab" : "default" }} draggable={!disabled} onDragStart={cloneElement} {...props}>{children}</div>);
}

export default InterchangeabilityList;